import React from 'react';
import './Skeleton.css';

export function Skeleton({ variant = 'text', width, height, className = '' }) {
  const style = {};
  if (width) style.width = width;
  if (height) style.height = height;

  return (
    <span
      className={`ui-skeleton ui-skeleton--${variant} ${className}`}
      style={style}
    />
  );
}
